import { cloneElement, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { VStack } from '@bonusly/design-system';

import { SmartNavLink } from './SmartNavLink';
import { TopLevelNavItem } from './TopLevelNavItem';
import { NavSectionConfig } from './types/nav';

interface NavSectionProps {
	section: NavSectionConfig;
	onNavLinkClick?: () => void;
}

export const NavSection: FC<NavSectionProps> = ({ section, onNavLinkClick }) => {
	const { t } = useTranslation('vertical_navbar');

	return (
		<TopLevelNavItem
			badgeCount={section.badgeCount}
			icon={cloneElement(<section.icon />, {
				color: 'secondary.fg',
				size: 'md',
				mt: 1.5,
			})}
			label={t(section.title as any)}
		>
			<VStack data-testid={section.id}>
				{section.links.map((link, index) => {
					return (
						<SmartNavLink
							badgeCount={link.badgeCount}
							key={index}
							label={typeof link.label === 'string' ? t(link.label) : link.label}
							matchActive={link.matchActive}
							url={link.url}
							isRecognizeRoute={link.isRecognizeRoute}
							external={link.external}
							onClick={onNavLinkClick}
						/>
					);
				})}
			</VStack>
		</TopLevelNavItem>
	);
};
